import { render, staticRenderFns } from "./ReplaceIngredientDialog.vue?vue&type=template&id=76f64b5c&"
import script from "./ReplaceIngredientDialog.vue?vue&type=script&lang=js&"
export * from "./ReplaceIngredientDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports